import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { Room, RoomType} from "../interfaces/Rooms";

export const getRooms = (params?: any) => {
  return new Promise((resolve, reject) => {
    let query = new URLSearchParams();
    if (params) {
      for (let key in params) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
          query.set(key, params[key]);
        }
      }
    }
    const queryString = query.toString();
    const url = queryString 
      ? `${BASE_URL}/api/v1/rooms?${queryString}`
      : `${BASE_URL}/api/v1/rooms`;
    
    api
      .get(url)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const addRoom = (payload: {
  name: string;
  floor: number;
  room_type_id: number;
  status: string;
  beds?: { name: string; type?: string }[];
}) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/rooms`, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getRoomById = (id: number): Promise<Room> => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/rooms/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const updateRoom = (id: number, payload: Omit<Room, "id">): Promise<Room> => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/rooms/${id}`, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getRoomTypes = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/room-types`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getRoomTypeById = (id: number): Promise<RoomType> => {
  return new Promise((resolve, reject) => {
    api.get(`${BASE_URL}/api/v1/room-types/${id}`)
      .then((res) => resolve(res.data.data))
      .catch((err) => reject(err));
  });
};

export const updateRoomType = (id: number, payload: Omit<RoomType, "id" | "created_at" | "updated_at">): Promise<RoomType> => {
  return new Promise((resolve, reject) => {
    api.put(`${BASE_URL}/api/v1/room-types/${id}`, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const addRoomType = (payload: {
  name: string;
  price_per_hour: number;
  price_per_day: number;
}) => {
  return api.post(`${BASE_URL}/api/v1/room-types`, payload);
};


